var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBillDollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 13,
  viewBox: "0 0 17 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.5897 1.5H2.13248C1.50703 1.5 1 2.00703 1 2.63248V10.5598C1 11.1853 1.50703 11.6923 2.13248 11.6923H14.5897C15.2152 11.6923 15.7222 11.1853 15.7222 10.5598V2.63248C15.7222 2.00703 15.2152 1.5 14.5897 1.5Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.36115 8.86097C9.61205 8.86097 10.6261 7.84691 10.6261 6.59601C10.6261 5.34511 9.61205 4.33105 8.36115 4.33105C7.11025 4.33105 6.09619 5.34511 6.09619 6.59601C6.09619 7.84691 7.11025 8.86097 8.36115 8.86097Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.57658 6.87679C3.42022 6.87679 3.29346 6.75003 3.29346 6.59367C3.29346 6.43731 3.42022 6.31055 3.57658 6.31055",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.57642 6.87679C3.73278 6.87679 3.85954 6.75003 3.85954 6.59367C3.85954 6.43731 3.73278 6.31055 3.57642 6.31055",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1464 6.87679C12.99 6.87679 12.8633 6.75003 12.8633 6.59367C12.8633 6.43731 12.99 6.31055 13.1464 6.31055",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1462 6.87679C13.3026 6.87679 13.4294 6.75003 13.4294 6.59367C13.4294 6.43731 13.3026 6.31055 13.1462 6.31055",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgBillDollar;